// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2b9Hw","amount":"Amount_amount__3iYvp","tip":"Amount_tip__JNddj","tipHeader":"Amount_tipHeader__1n716","tipsWrap":"Amount_tipsWrap__IwzlC"};